/**
 * DrawerShell — shell estándar de drawer lateral del admin.
 *
 * Lo usan los componentes de "Nueva operación", "Solicitar crédito",
 * "Anular movimiento", etc. Mantiene el mismo look y comportamiento:
 *   - Backdrop semi-opaco que cierra al hacer click
 *   - Aside fijo a la derecha de ancho fijo
 *   - Header con título y botón X
 *   - Slot para el contenido
 *
 * El título es opcional. Si no se pasa, se renderea sin header (los
 * drawers que prefieren armar su propio header pueden omitirlo).
 */
import type { ReactNode } from 'react'
import { X as XIcon } from '@phosphor-icons/react'

export function DrawerShell({
  onClose, title, children,
}: {
  onClose: () => void
  title?: string
  children: ReactNode
}) {
  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: 'fixed', inset: 0, background: 'rgba(15, 18, 25, 0.40)',
          zIndex: 999,
        }}
      />
      <aside
        style={{
          position: 'fixed', top: 0, right: 0, bottom: 0,
          width: 'min(440px, 100%)',
          background: 'var(--surface)',
          boxShadow: '-12px 0 32px rgba(0,0,0,0.10)',
          zIndex: 1000,
          display: 'flex', flexDirection: 'column',
        }}
      >
        {title !== undefined && (
          <div style={{
            padding: '18px 24px', borderBottom: '1px solid var(--hairline)',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--ink)' }}>
              {title}
            </div>
            <button
              type="button"
              onClick={onClose}
              aria-label="Cerrar"
              style={{ all: 'unset', cursor: 'pointer', padding: 6, color: 'var(--muted-foreground)' }}
            >
              <XIcon size={16} weight="bold" />
            </button>
          </div>
        )}
        {children}
      </aside>
    </>
  )
}
